module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "pwc.a623d6ab.png";